import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import IndeterminateCheckBoxIcon from "@material-ui/icons/IndeterminateCheckBox";
import AddBoxIcon from "@material-ui/icons/AddBox";
import EditIcon from '@material-ui/icons/Edit';

import {
  alertsConfirmAction,
  auditPlanOpenAction,
} from "../features/sliceReducer/interactionReducer";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../features/store";
import { deleteAuditPlanAction } from "../features/sliceReducer/projectReducer";
import { initializeIPSchedule } from "../models/IPSchedule";
import IPUtility from "../classes/IPUtility";

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    caption: {
      padding: "24px 0 0 24px",
      fontWeight: "bold",
      fontSize: "18px",
    },
    tableContainer: {
      position: "relative",
      display: "flex",
      padding: "0px 24px 40px",
    },
    table: {
      "& .MuiTableCell-root": {
        padding: "12px",
      },
    },
    addButton: {
      position: "absolute",
      padding: "16px",
      top: 0,
      right: 0,
    },
  })
);

interface AuditPlanProps {
  editHandler: any;
}

const AuditPlan = (props: AuditPlanProps) => {
  const classes = useStyle();
  const dispatch = useDispatch();

  const { currentProject } = useSelector((state: RootState) => state.project);

  return (
    <React.Fragment>
      <Box>
        <Typography variant="subtitle1">
          <PersonAddIcon
            style={{ marginRight: "8px", verticalAlign: "middle" }}
          />
          세부감사계획 및 대상
        </Typography>
        <Box className={classes.tableContainer}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>일시</TableCell>
                {/* <TableCell>대상부서</TableCell>
                <TableCell>감사내용</TableCell>
                <TableCell>비고</TableCell> */}
                <TableCell align="right">
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddBoxIcon />}
                    onClick={() => {
                      props.editHandler({ ...initializeIPSchedule, uuid: IPUtility.generateUUID() });
                      dispatch(auditPlanOpenAction());
                    }}
                  >
                    추가
                  </Button>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {currentProject?.schedules?.map((schedule, index) => (
                <TableRow key={index}>
                  <TableCell>{schedule.date}</TableCell>
                  {/* <TableCell>{schedule.department}</TableCell>
                  <TableCell>{schedule.contents}</TableCell>
                  <TableCell>{schedule.note}</TableCell> */}
                  <TableCell align="right">
                    <Box>
                      <Button
                        onClick={() => {
                          dispatch(
                            alertsConfirmAction({
                              alertContent: "해당 스케줄을 삭제하시겠습니까?",
                              alertAction: deleteAuditPlanAction(schedule.uuid),
                            })
                          );
                        }}
                      >
                        <IndeterminateCheckBoxIcon
                          style={{
                            color: "#f44336",
                            fontSize: "26px",
                          }}
                        />
                      </Button>
                      <Button onClick={() => {
                        dispatch(auditPlanOpenAction());
                        props.editHandler(schedule);
                      }}>
                        <EditIcon />
                      </Button>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Box>
    </React.Fragment >
  );
};

export default AuditPlan;
